import wixEcomBackend from 'wix-ecom-backend'
import wixEcomFrontend from 'wix-ecom-frontend'
import wixSiteFrontend from "wix-site-frontend"
import { loadGifts } from 'public/load-gifts.js'
import { session } from 'wix-storage'
import wixWindow from 'wix-window'
import { cart } from 'wix-stores-frontend'
import { getRefreshCartFlag, setRefreshCartFlag } from 'public/refreshCartFlag.js'
import { expandClaimYourGift } from 'public/showClaimYourGiftInCart.js'
import wixLocation from 'wix-location'
import { checkout } from "wix-ecom-backend"

let previousCartItems = []

async function getCheckoutData() {
    try {
        const params = new URLSearchParams(new URL(wixLocation.url).search);
        const appSectionParams = params.get('appSectionParams');

        if (appSectionParams) {
            const decodedParams = JSON.parse(decodeURIComponent(appSectionParams));
            const retrievedCheckout = await checkout.getCheckout(decodedParams.checkoutId);
            console.log("Retrieved checkout:", retrievedCheckout);
            return retrievedCheckout;
        }
        return null;
    } catch (error) {
        console.error("Error getting checkout:", error);
        return null;
    }
}

$w.onReady(async function () {
    console.log("onReady started");
    let storedGifts

    if (session.getItem("storedGifts")) {
        console.log("Getting gifts from session");
        storedGifts = JSON.parse(session.getItem("storedGifts"))
    } else {
        console.log("Loading gifts from backend");
        storedGifts = await loadGifts()
        session.setItem("storedGifts", JSON.stringify(storedGifts))
    }
    console.log("Stored gifts:", storedGifts);

    const handler = async () => {
        console.log("Handler called");
        if (getRefreshCartFlag()) {
            console.log("Refresh flag is true, returning");
            setTimeout(() => setRefreshCartFlag(false), 2000)
            return
        }

        try {
            const isCheckout = wixLocation.url.includes('checkout');
            console.log("Is checkout page:", isCheckout);

            let currentItems;
            let subtotalAmount;

            if (isCheckout) {
                const checkoutData = await getCheckoutData();
                if (!checkoutData) {
                    console.log("No checkout data found");
                    return;
                }
                currentItems = checkoutData.lineItems;
                subtotalAmount = checkoutData.priceSummary.subtotal.amount;
            } else {
                const userCart = await wixEcomBackend.currentCart.getCurrentCart();
                currentItems = userCart.lineItems;
                subtotalAmount = userCart.subtotal.amount;
            }

            console.log("Current items:", currentItems);
            const currentPage = wixSiteFrontend.currentPage;
            console.log("Current page:", currentPage.name);
            const currentDate = new Date();

            const existingGiftInCart = currentItems.some(item =>
                storedGifts.some(gift => gift.giftProduct?.productId === item.catalogReference.catalogItemId)
            )
            console.log("Existing gift in items:", existingGiftInCart);

            if (existingGiftInCart) {
                console.log("Gift already in cart/checkout - skipping gift offer")
                previousCartItems = currentItems
                return
            }

            const qualifyingGift = storedGifts.find(gift => {
                const giftEndDate = new Date(gift.endDate)
                const isBeforeEndDate = currentDate <= giftEndDate
                console.log("Gift end date check:", gift.giftTitle, isBeforeEndDate);

                const hasRelatedProduct = currentItems.some(item =>
                    gift.relatedProducts.some(relatedProduct =>
                        relatedProduct.productId === item.catalogReference.catalogItemId
                    )
                )
                console.log("Has related product:", gift.giftTitle, hasRelatedProduct);

                const meetsAmountRequirement = Number(subtotalAmount) >= gift.giftAmount
                console.log("Meets amount requirement:", gift.giftTitle, meetsAmountRequirement,
                    `(Amount: ${subtotalAmount} >= Required: ${gift.giftAmount})`);

                const giftAlreadyInItems = currentItems.some(item =>
                    item.catalogReference.catalogItemId === gift.giftProduct.productId
                )
                console.log("Gift already in items:", gift.giftTitle, giftAlreadyInItems);

                return isBeforeEndDate && (hasRelatedProduct || meetsAmountRequirement) && !giftAlreadyInItems
            })

            console.log("Qualifying gift:", qualifyingGift);

            if (qualifyingGift && qualifyingGift.giftProduct.inStock) {
                console.log("Found qualifying gift in stock");
                if (currentPage.name.toLowerCase() === "cart") {
                    console.log("On cart page, expanding claim gift");
                    expandClaimYourGift(qualifyingGift)
                } else {
                    console.log("Opening lightbox for checkout or regular page");
                    cart.hideMiniCart()
                    wixWindow.openLightbox("GiftLightbox", qualifyingGift)
                }
            } else {
                console.log("No qualifying gift found or gift out of stock");
            }

            previousCartItems = currentItems
        } catch (error) {
            console.error("Error in handler:", error)
            console.error("Error stack:", error.stack)
        }
    }

    console.log("Setting up cart change listener");
    wixEcomFrontend.onCartChange(handler)

    console.log("Running initial handler");
    handler()
})